import Underscore from "underscore";
import UnderscoreString from "underscore.string";
import $ from "jquery";
import $mockjax from "jquery-mockjax";

// Most of the app assumes these are globally available.
// Define them as non-writable properties so that they can't be overwritten.
Object.defineProperty(window, "_", { value: Underscore });
Object.defineProperty(window._, "str", { value: UnderscoreString });
Object.defineProperty(window, "$", { value: $ });
$mockjax(window.$, window);



// WEBPACK FOOTER //
// ./src/globals.js